import React from 'react';

type Props = {
  className?: string;
};

const AiCheckoutPersonalisation = ({ className = '' }: Props) => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g filter="url(#filter0_biii_3544_16299)">
      <circle
        cx="12.5"
        cy="12.5"
        r="12"
        fill="url(#paint0_linear_3544_16299)"
      />
      <circle
        cx="12.5"
        cy="12.5"
        r="12"
        fill="url(#paint1_radial_3544_16299)"
        fillOpacity="0.5"
      />
      <circle
        cx="12.5"
        cy="12.5"
        r="12"
        fill="url(#paint2_radial_3544_16299)"
        fillOpacity="0.8"
      />
      <circle
        cx="12.5"
        cy="12.5"
        r="11.8331"
        stroke="url(#paint3_linear_3544_16299)"
        strokeOpacity="0.3"
        strokeWidth="0.333702"
      />
    </g>
    <path
      d="M19.3441 12.6744L16.8605 12.1153C15.272 11.7493 14.3413 10.8515 13.9045 9.72338L12.8116 6.00533C12.783 5.93186 12.7135 5.8335 12.4996 5.8335C12.3195 5.8335 12.2161 5.93186 12.1875 6.00533L11.0946 9.72462C10.656 10.8527 9.72715 11.7505 8.13859 12.1166L5.65501 12.6757C5.30378 12.7553 5.29843 13.1015 5.64788 13.1849L8.14929 13.7863C9.7325 14.1537 10.656 15.0502 11.0946 16.1733L12.1893 19.8503C12.2179 19.9237 12.2767 20.0557 12.5013 20.0557C12.7385 20.0557 12.7848 19.9237 12.8133 19.8503L13.908 16.1733C14.3466 15.0489 15.2702 14.1524 16.8534 13.7863L19.3548 13.1849C19.7007 13.1003 19.6953 12.7541 19.3441 12.6744Z"
      fill="#FDD835"
    />
    <path
      d="M19.5788 12.828C19.5396 12.7595 19.4629 12.6997 19.3435 12.6724L16.8599 12.1133C15.2713 11.7472 14.3407 10.8494 13.9039 9.72133L12.8109 6.00328C12.7949 5.96094 12.7378 5.88374 12.6719 5.86133L13.0249 9.59307C13.287 11.2965 13.5116 12.0983 15.4585 12.3324C17.1309 12.5341 19.0653 12.7657 19.5788 12.828Z"
      fill="#FFEE58"
    />
    <path
      d="M19.5805 13.0253L15.273 13.7151C13.7558 13.984 12.9196 14.5979 12.9196 16.2042L12.4971 20.0567C12.6415 20.0467 12.7592 19.9919 12.8091 19.8512L13.9038 16.1743C14.3424 15.0499 15.2659 14.1534 16.8491 13.7873L19.3505 13.1859C19.4682 13.156 19.5431 13.095 19.5805 13.0253Z"
      fill="#F4B400"
    />
    <defs>
      <filter
        id="filter0_biii_3544_16299"
        x="-4.50554"
        y="-4.50554"
        width="34.0111"
        height="34.0111"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="2.50277" />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_3544_16299"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_backgroundBlur_3544_16299"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="4.33813" dy="2.33592" />
        <feGaussianBlur stdDeviation="3.83758" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_3544_16299"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-4.33813" dy="-1.00111" />
        <feGaussianBlur stdDeviation="9.67737" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0.835294 0 0 0 0 0.960784 0 0 0 0.21 0"
        />
        <feBlend
          mode="normal"
          in2="effect2_innerShadow_3544_16299"
          result="effect3_innerShadow_3544_16299"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="2.33592" dy="-3.00332" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.992157 0 0 0 0 0.658824 0 0 0 0 1 0 0 0 0.27 0"
        />
        <feBlend
          mode="soft-light"
          in2="effect3_innerShadow_3544_16299"
          result="effect4_innerShadow_3544_16299"
        />
      </filter>
      <linearGradient
        id="paint0_linear_3544_16299"
        x1="16.2874"
        y1="1.21761"
        x2="9.07143"
        y2="24.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.26" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <radialGradient
        id="paint1_radial_3544_16299"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(17.1645 4.84552) rotate(119.781) scale(23.8394)"
      >
        <stop stopColor="white" stopOpacity="0" />
        <stop offset="0.62353" stopColor="#FDA8FF" stopOpacity="0" />
        <stop offset="1" stopColor="#FDA8FF" />
      </radialGradient>
      <radialGradient
        id="paint2_radial_3544_16299"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(9.2309 26.5332) rotate(-75.2603) scale(29.9284)"
      >
        <stop stopColor="#6930CA" />
        <stop offset="0.285" stopColor="#6930CA" />
        <stop offset="1" stopColor="#6930CA" />
      </radialGradient>
      <linearGradient
        id="paint3_linear_3544_16299"
        x1="18.7193"
        y1="2.37375"
        x2="4.40698"
        y2="22.7857"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5800ED" />
        <stop offset="1" stopColor="#FEC8FF" />
      </linearGradient>
    </defs>
  </svg>
);

export default AiCheckoutPersonalisation;
